import React, { useState } from 'react';
import { signedChatFile } from '../../lib/m9AppChat';
import { supabaseClient } from '../../config/supabase';
export default function AppChatMessageMeta({ item, peerReadAt, client = supabaseClient }) {
    const [error, setError] = useState('');
    const open = async () => {
        const tab = window.open('about:blank', '_blank'); if (tab) tab.opener = null;
        try { const file = await signedChatFile(client, item.appFile?.file_id); if (tab) tab.location.href = file.url; }
        catch (failure) { tab?.close(); setError(failure.message); }
    };
    return <>
        {item.tripId && <a className="inline-flex min-h-[44px] items-center rounded-full border border-[#22C55E] px-3" href={`/dispatch?engagement=${item.tripId}`}>Trip {item.tripLabel || 'details'}{item.isTest ? ' · TEST' : ''}</a>}
        {item.appFile && <button type="button" className="ia-btn3d min-h-[44px] max-w-full break-words" onClick={open}>📎 {item.appFile.name || 'Attachment'}</button>}
        {item.direction === 'outbound' && <small className="block">{peerReadAt && Date.parse(peerReadAt) >= item.at ? 'Read by client' : 'Sent in App chat'}</small>}
        {error && <p role="alert">{error}</p>}
    </>;
}
